'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Text = undefined;

var _themeProvider = require('@spp/theme-provider');

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.Text = _Text2.default;
exports.default = (0, _themeProvider.themer)('@spp/ui-text')(_Text2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-text/lib/cjs/index.js
 ** module id = 173
 ** module chunks = 1
 **/